import React from 'react';
import { CTAButton } from '../components/CTAButton';
import { SectionReveal } from '../components/SectionReveal';
export function FinalCTASection() {
  return <section className="relative w-full bg-brand-dark py-20 md:py-28 overflow-hidden" data-id="element-77">
      <div className="absolute top-0 left-0 right-0 h-1 bg-gradient-to-r from-transparent via-brand-gold/30 to-transparent" data-id="element-78" />

      <div className="relative z-10 max-w-3xl mx-auto px-4 text-center" data-id="element-79">
        <SectionReveal data-id="element-80">
          <p className="text-4xl mb-4" data-id="element-81">🚀</p>
          <h2 className="font-heading font-bold text-2xl sm:text-3xl md:text-4xl text-white mb-4 uppercase leading-tight" data-id="element-82">
            No sigas perdiendo plata todos los meses.
          </h2>
          <p className="text-xl sm:text-2xl text-brand-gold font-body font-bold mb-10" data-id="element-83">
            Empezá a pagar lo que realmente corresponde.
          </p>
        </SectionReveal>

        <SectionReveal delay={0.15} data-id="element-84">
          <CTAButton text="DESCARGAR GUÍA AHORA" size="xl" data-id="element-85" />
        </SectionReveal>
      </div>

      {/* Footer */}
      <div className="relative z-10 max-w-3xl mx-auto px-4 mt-20 pt-8 border-t border-gray-800" data-id="element-86">
        <p className="text-center text-gray-600 font-body text-sm" data-id="element-87">
          © {new Date().getFullYear()} Ahorro Total · Todos los derechos
          reservados
        </p>
      </div>
    </section>;
}